<template>
  <div>
    <v-col md="12" ref="settingFence">
      <v-row no-gutters>
        <v-col cols="6">
          <v-row>
            <span class="headline">{{ $t("draw") }}</span>
          </v-row>

          <v-row>
            <v-radio-group v-model="objectType" row>
              <v-radio :label="$t('fenceBox')" value="FenceBox"></v-radio>

              <v-radio
                :label="$t('fencePolygon')"
                value="FencePolygon"
              ></v-radio>
            </v-radio-group>
          </v-row>

          <v-row>
            <v-btn class="ma-2" color="primary" @click="objectType = 'Edit'">
              {{ $t("finish") }} {{ $t("draw") }}
            </v-btn>

            <v-btn class="ma-2" color="primary" @click="restoreObject">
              {{ $t("restore") }}
            </v-btn>
          </v-row>
        </v-col>

        <v-col cols="6">
          <v-row>
            <span class="headline">{{ $t("action") }}</span>
          </v-row>

          <v-row>
            <v-btn class="ma-2" color="primary" medium @click="removeObject"
              >{{ $t("remove") }} {{ $t("object") }}</v-btn
            >

            <v-btn class="ma-2" color="primary" @click="removeAllObjects">
              {{ $t("remove") }} {{ $t("all") }} {{ $t("object") }}</v-btn
            >
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="8">
          <div class="fenceCanvas" ref="fenceCanvas">
            <v-stage
              ref="stage"
              :config="stageSize"
              @mousemove="handleMouseMove"
              @mouseDown="handleMouseDown"
              @mouseUp="handleMouseUp"
              @dragstart="handleDragStart"
              @dragend="handleDragEnd"
            >
              <v-layer ref="layer">
                <v-image :config="baseImage" />

                <v-group
                  v-for="(box, index) in objects.FenceBox"
                  :key="'box' + index"
                  :config="{
                    uuid: box.uuid,
                    type: box.type,
                    name: box.name,
                    x: box.startPointX * baseImage.width,
                    y: box.startPointY * baseImage.height,
                    draggable: draggable,
                  }"
                  @dblclick="changeObjectSetting(box)"
                >
                  <v-text
                    :config="{
                      x: 5,
                      y: 5,
                      text: box.name,
                      fill: box.stroke_color,
                      fontSize: 15,
                    }"
                  />

                  <v-rect
                    :config="{
                      width: box.width * baseImage.width,
                      height: box.height * baseImage.height,
                      fill: box.fill_color,
                      stroke: box.stroke_color,
                      strokeWidth: 3,
                      opacity: 0.4,
                    }"
                  />
                </v-group>

                <v-group
                  v-for="(polygon, index) in objects.FencePolygon"
                  :key="'polygon' + index"
                  :config="{
                    uuid: polygon.uuid,
                    type: polygon.type,
                    name: polygon.name,
                    x: polygon.startPointX * baseImage.width,
                    y: polygon.startPointY * baseImage.height,
                    draggable: draggable,
                  }"
                  @dblclick="changeObjectSetting(polygon)"
                >
                  <v-text
                    :config="{
                      x: 5,
                      y: 5,
                      text: polygon.name,
                      fill: polygon.stroke_color,
                      fontSize: 15,
                    }"
                  />

                  <v-circle
                    v-for="(breakPoint, index) in polygon.breakPoints"
                    :key="'breakPoint' + index"
                    :config="{
                      x: breakPoint.x * baseImage.width,
                      y: breakPoint.y * baseImage.height,
                      radius: 5,
                      fill: breakPoint.color,
                    }"
                  />

                  <v-line
                    v-for="(polygonPoint, index) in polygon.polygonPoints"
                    :key="'polygonPoint' + index"
                    :config="{
                      x: polygonPoint[0],
                      y: polygonPoint[1],
                      points: polygon.polygonPoints,
                      fill: polygon.fill_color,
                      stroke: polygon.stroke_color,
                      strokeWidth: 5,
                      opacity: 0.05,
                      closed: true,
                    }"
                  />
                </v-group>
              </v-layer>
            </v-stage>
          </div>
        </v-col>

        <v-col cols="4">
          <v-row>
            <div>
              {{ $t("total") }} {{ $t("object") }} {{ $t("count") }}:
              {{ objectsCount }}
            </div>
          </v-row>

          <v-row v-if="selectedObject != null">
            <v-col cols="12">
              <v-text-field
                v-model="objectSetting.name"
                :label="$t('setting') + ' ' + $t('name').toLowerCase()"
              ></v-text-field>
            </v-col>

            <v-col cols="12" v-if="false">
              <v-text-field
                v-model="objectSetting.coolDown"
                :label="
                  $t('setting') +
                  ' ' +
                  $t('coolDown').toLowerCase() +
                  '(' +
                  $t('second').toLowerCase() +
                  ')'
                "
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import { getSnapshot } from "@/endpoint/camera";
import {
  getInferenceCameras,
  getFences,
  addFence,
  updateFence,
  removeFence,
} from "@/endpoint/inferenceCamera";

export default {
  name: "GuardianFencePlate",
  data() {
    return {
      isDrawing: false,
      isDragging: false,
      width: 1280,
      height: 720,
      originalImageSize: {
        width: 100,
        height: 100,
      },
      baseImage: {
        image: null,
        width: this.width,
        height: this.height,
      },
      stageSize: {
        width: this.width,
        height: this.height,
      },
      item: {},
      objectType: "Edit",
      objectSetting: {
        name: "",
        coolDown: "",
      },
      selectedObject: null,
      objects: {
        FenceBox: [],
        FencePolygon: [],
      },
      objectRestorePoints: [],
      supportFenceTypes: ["FenceBox", "FencePolygon"],
      fenceData: {},
      fenceItems: [],
      inferenceCameraItems: [],
    };
  },
  created() {
    this.init(this);
  },
  mounted() {
    window.addEventListener("resize", this.changeScreenSize);
    this.changeScreenSize();
  },
  watch: {
    width() {
      this.stageSize.width = this.width;
      this.baseImage.width = this.stageSize.width;

      this.resizePolygons();
    },
    height() {
      if (
        this.originalImageSize.width != 0 &&
        this.originalImageSize.height != 0
      ) {
        this.stageSize.height =
          (this.originalImageSize.height / this.originalImageSize.width) *
          this.stageSize.width;
        this.baseImage.height = this.stageSize.height;
      }
      this.resizePolygons();
    },
    "objectSetting.name"() {
      if (this.selectedObject != null) {
        this.selectedObject.name = this.objectSetting.name;
      }
    },
    selectedObject(newVal, oldVal) {
      if (oldVal != null) {
        oldVal.stroke_color = "blue";
      }
      if (newVal != null) {
        newVal.stroke_color = "yellow";
      }
    },
    objectType(newVal, oldVal) {
      if (oldVal == "FencePolygon" && this.isDrawing) {
        const ploygon =
          this.objects["FencePolygon"][this.objects["FencePolygon"].length - 1];
        ploygon.fill_color = "red";
      }
      this.isDrawing = false;

      if (newVal != "Edit") {
        this.selectedObject = null;
      }
    },
  },
  computed: {
    objectsCount() {
      return this.objects.FenceBox.length + this.objects.FencePolygon.length;
    },
    draggable() {
      return this.objectType == "Edit";
    },
  },
  methods: {
    async init(scope) {
      const inferenceCameraUuid = scope.$route.params.uuid;

      scope.inferenceCameraItems = await getInferenceCameras();

      scope.inferenceCameraItem = scope.inferenceCameraItems.find(function (
        item
      ) {
        return item._id == inferenceCameraUuid;
      });

      scope.loadBaseImage(scope.inferenceCameraItem.camera.camera_id);

      if (scope.inferenceCameraItem._id != undefined) {
        scope.fenceItems = await getFences(scope.inferenceCameraItem._id);

        scope.fenceData = JSON.parse(JSON.stringify(scope.fenceItems));
        scope.fenceDataToObject();
      } else {
        scope.objects = {
          FenceBox: [],
          FencePolygon: [],
        };
      }

      scope.setObjectRestorePoint();

      return scope;
    },
    fenceDataToObject() {
      this.fenceData.forEach((data) => {
        if (data.type == "FenceBox") {
          this.objects["FenceBox"].push({
            order: this.fenceData.indexOf(data),
            uuid: data._id,
            name: data.name,
            type: data.type,
            fill_color: "red",
            stroke_color: "blue",
            startPointX: parseFloat(data.min.x.toFixed(4)),
            startPointY: parseFloat(data.min.y.toFixed(4)),
            width: parseFloat((data.max.x - data.min.x).toFixed(4)),
            height: parseFloat((data.max.y - data.min.y).toFixed(4)),
          });
        } else if (data.type == "FencePolygon") {
          let points = [];
          let polygonPoints = [];
          let breakPoints = [];
          let startPointX = parseFloat(data.points[0].x.toFixed(4));
          let startPointY = parseFloat(data.points[0].y.toFixed(4));
          data.points.forEach((point) => {
            points.push({
              x: parseFloat((point.x - startPointX).toFixed(4)),
              y: parseFloat((point.y - startPointY).toFixed(4)),
            });
            polygonPoints.push(
              parseFloat((point.x - startPointX).toFixed(4)) *
                this.baseImage.width
            );
            polygonPoints.push(
              parseFloat((point.y - startPointY).toFixed(4)) *
                this.baseImage.height
            );
            breakPoints.push({
              color: data.points.indexOf(point) == 0 ? "red" : "blue",
              x: parseFloat((point.x - startPointX).toFixed(4)),
              y: parseFloat((point.y - startPointY).toFixed(4)),
            });
          });
          this.objects["FencePolygon"].push({
            order: this.fenceData.indexOf(data),
            uuid: data._id,
            name: data.name,
            type: data.type,
            fill_color: "red",
            stroke_color: "blue",
            startPointX: parseFloat(startPointX.toFixed(4)),
            startPointY: parseFloat(startPointY.toFixed(4)),
            points: points,
            polygonPoints: polygonPoints,
            breakPoints: breakPoints,
          });
        }
      });
    },
    objectToFenceData() {
      let fenceData = [];
      this.supportFenceTypes.forEach((type) => {
        this.objects[type].forEach((data) => {
          if (type == "FenceBox") {
            let fenceBoxX = [
              parseFloat(data.startPointX.toFixed(4)),
              parseFloat((data.startPointX + data.width).toFixed(4)),
            ];
            let fenceBoxY = [
              parseFloat(data.startPointY.toFixed(4)),
              parseFloat((data.startPointY + data.height).toFixed(4)),
            ];
            fenceData.push({
              _id: data.uuid,
              type: data.type,
              name: data.name,
              min: { x: Math.min(...fenceBoxX), y: Math.min(...fenceBoxY) },
              max: { x: Math.max(...fenceBoxX), y: Math.max(...fenceBoxY) },
            });
          } else if (type == "FencePolygon") {
            let points = [];

            data.points.forEach((point) => {
              points.push({
                x: parseFloat((data.startPointX + point.x).toFixed(4)),
                y: parseFloat((data.startPointY + point.y).toFixed(4)),
              });
            });
            fenceData.push({
              _id: data.uuid,
              type: data.type,
              name: data.name,
              points: points,
            });
          }
        });
      });
      return fenceData;
    },
    changeScreenSize() {
      const fenceCanvas = this.$refs.fenceCanvas;

      if (!fenceCanvas) {
        return;
      }
      if (
        this.originalImageSize.width != 0 &&
        this.originalImageSize.height != 0
      ) {
        this.width = fenceCanvas.offsetWidth;
        this.height =
          (this.originalImageSize.height / this.originalImageSize.width) *
          this.width;
      }
    },
    loadBaseImage(camera_id) {
      let snapshot = null;
      let image = new Image();

      image.onload = () => {
        this.baseImage.image = image;
        this.baseImage.width = this.width;
        this.baseImage.height = this.height;
      };

      (async () => {
        snapshot = await getSnapshot(camera_id);
        this.originalImageSize.width = snapshot.size.x;
        this.originalImageSize.height = snapshot.size.y;
        this.changeScreenSize();
        image.src = snapshot.data;
      })();
    },
    setObject(element) {
      const objectType = element[element.length - 1].type;
      this.objects[objectType] = element;
    },
    setObjectRestorePoint() {
      let lastObjects = JSON.parse(JSON.stringify(this.objects));
      this.objectRestorePoints.push(lastObjects);
    },
    restoreObject() {
      this.objects = JSON.parse(JSON.stringify(this.objectRestorePoints[0]));
    },
    removeObject() {
      if (this.selectedObject != null) {
        let selectedObjectIndex = this.objects[
          this.selectedObject.type
        ].findIndex((object) => object == this.selectedObject);
        this.objects[this.selectedObject.type].splice(selectedObjectIndex, 1);
        this.reorderObjects(this.selectedObject.order);

        this.selectedObject = null;
      }
    },
    removeAllObjects() {
      const objectTypes = ["FenceBox", "FencePolygon"];
      objectTypes.forEach((objectType) => {
        this.objects[objectType] = [];
      });
      this.isDrawing = false;
      this.selectedObject = null;
    },
    reorderObjects(order) {
      const objectTypes = ["FenceBox", "FencePolygon"];
      objectTypes.forEach((objectType) => {
        this.objects[objectType].forEach((object) => {
          if (object.order > order) {
            object.order -= 1;
          }
        });
      });
    },
    CheckObjectsClicked(pos) {
      let clickedObjects = [];
      const objectTypes = ["FenceBox", "FencePolygon"];
      const posX = pos.x / this.baseImage.width;
      const posY = pos.y / this.baseImage.height;

      objectTypes.forEach((objectType) => {
        let clickedObject = this.objects[objectType].filter((object) => {
          let check = false;
          let offsetX, offsetY;
          if (objectType == "FenceBox") {
            offsetX = object.width;
            offsetY = object.height;
          }

          if (objectType == "FenceBox") {
            if (offsetX >= 0 && offsetY >= 0) {
              check =
                posX >= object.startPointX &&
                posX <= object.startPointX + offsetX &&
                posY >= object.startPointY &&
                posY <= object.startPointY + offsetY;
            } else if (offsetX < 0 && offsetY >= 0) {
              check =
                posX >= object.startPointX + offsetX &&
                posX <= object.startPointX &&
                posY >= object.startPointY &&
                posY <= object.startPointY + offsetY;
            } else if (offsetX < 0 && offsetY < 0) {
              check =
                posX >= object.startPointX + offsetX &&
                posX <= object.startPointX &&
                posY >= object.startPointY + offsetY &&
                posY <= object.startPointY;
            } else if (offsetX >= 0 && offsetY < 0) {
              check =
                posX >= object.startPointX &&
                posX <= object.startPointX + offsetX &&
                posY >= object.startPointY + offsetY &&
                posY <= object.startPointY;
            }
          } else if (objectType == "FencePolygon") {
            const minX = Math.min(...object.points.map((point) => point.x));
            const minY = Math.min(...object.points.map((point) => point.y));
            const maxX = Math.max(...object.points.map((point) => point.x));
            const maxY = Math.max(...object.points.map((point) => point.y));
            check =
              posX >= object.startPointX + minX &&
              posX <= object.startPointX + maxX &&
              posY >= object.startPointY + minY &&
              posY <= object.startPointY + maxY;
          }
          return check;
        });
        clickedObjects = [...clickedObjects, ...clickedObject];
      });

      return clickedObjects;
    },
    changeObjectSetting(object) {
      if (this.objectType == "Edit") {
        this.selectedObject = object;
        this.objectSetting.name = this.selectedObject.name;
      }
    },
    resizePolygons() {
      this.objects["FencePolygon"].forEach((polygon) => {
        let newPolygonPoints = [];
        polygon.points.forEach((point) => {
          newPolygonPoints.push(point.x * this.baseImage.width);
          newPolygonPoints.push(point.y * this.baseImage.height);
        });
        polygon.polygonPoints = newPolygonPoints;
      });
    },
    handleMouseDown() {
      const pos = this.$refs.stage.getNode().getPointerPosition();

      // Check if Polygon is closed
      if (this.objectType == "FencePolygon" && this.isDrawing) {
        const curObject =
          this.objects[this.objectType][
            this.objects[this.objectType].length - 1
          ];
        if (
          this.calculateP2PDistance(
            curObject.startPointX,
            curObject.startPointY,
            pos.x / this.baseImage.width,
            pos.y / this.baseImage.height
          ) <= 0.01
        ) {
          curObject.fill_color = "red";
          this.isDrawing = false;
          return;
        }
        // Keep drawing Polygon
        let pointX = pos.x / this.baseImage.width - curObject.startPointX;
        let pointY = pos.y / this.baseImage.height - curObject.startPointY;

        curObject.points = [...curObject.points, { x: pointX, y: pointY }];
        curObject.polygonPoints = [
          ...curObject.polygonPoints,
          pointX * this.baseImage.width,
          pointY * this.baseImage.height,
        ];
        curObject.breakPoints = [
          ...curObject.breakPoints,
          {
            color: "blue",
            x: pointX,
            y: pointY,
          },
        ];
        return;
      }

      // Check if Clicked position is empty
      if (this.objectType != "Edit") {
        this.isDrawing = true;
        const uuid = this.createUuid();
        if (this.objectType == "FenceBox") {
          // New Box
          this.setObject([
            ...this.objects.FenceBox,
            {
              order: this.objectsCount + 1,
              uuid: uuid,
              name: "Box-" + uuid.substring(0, 4),
              type: "FenceBox",
              fill_color: "red",
              stroke_color: "blue",
              startPointX: pos.x / this.baseImage.width,
              startPointY: pos.y / this.baseImage.height,
              width: 0,
              height: 0,
            },
          ]);
        } else if (this.objectType == "FencePolygon") {
          // New Polygon
          this.setObject([
            ...this.objects.FencePolygon,
            {
              order: this.objectsCount + 1,
              uuid: uuid,
              name: "Polygon-" + uuid.substring(0, 4),
              type: "FencePolygon",
              fill_color: "white",
              stroke_color: "blue",
              startPointX: pos.x / this.baseImage.width,
              startPointY: pos.y / this.baseImage.height,
              points: [{ x: 0, y: 0 }],
              polygonPoints: [0, 0],
              breakPoints: [{ color: "red", x: 0, y: 0 }],
            },
          ]);
        }
      }
    },
    handleMouseMove() {
      if (!this.isDrawing) {
        return;
      }
      const pos = this.$refs.stage.getNode().getPointerPosition();
      const curObject =
        this.objects[this.objectType][this.objects[this.objectType].length - 1];
      if (this.objectType == "FenceBox") {
        curObject.width = pos.x / this.baseImage.width - curObject.startPointX;
        curObject.height =
          pos.y / this.baseImage.height - curObject.startPointY;
      } else if (this.objectType == "FencePolygon") {
        return;
        // let curPolygon = this.objects[this.objectType][
        //   this.objects[this.objectType].length - 1
        // ];
        // let pointX =
        //   pos.x / this.baseImage.width -
        //   curPolygon.points[curPolygon.points.length - 2];
        // let pointY =
        //   pos.y / this.baseImage.height -
        //   curPolygon.points[curPolygon.points.length - 1];
        // window.console.log(pointX, pointY);
        // let newPoints =
        //   curPolygon.points.length <= 4
        //     ? [0, 0, pointX, pointY]
        //     : curPolygon.points.splice(
        //         0,
        //         curPolygon.points.length - 2,
        //         pointX,
        //         pointY
        //       );
        // curPolygon.points = newPoints;
        // let newPolygonPoints =
        //   curPolygon.points.length <= 4
        //     ? [0, 0, pointX, pointY]
        //     : curPolygon.points.splice(
        //         0,
        //         curPolygon.points.length - 2,
        //         pointX * this.baseImage.width,
        //         pointY * this.baseImage.height
        //       );
        // curPolygon.polygonPoints = newPolygonPoints;
        // curPolygon.breakPoints = newPolygonPoints;
      }
    },
    handleMouseUp() {
      const pos = this.$refs.stage.getNode().getPointerPosition();
      if (this.objectType != "Edit") {
        const curObject =
          this.objects[this.objectType][
            this.objects[this.objectType].length - 1
          ];
        if (this.objectType != "FencePolygon") {
          // Avoid click with draw
          if (
            this.calculateP2PDistance(
              curObject.startPointX,
              curObject.startPointY,
              pos.x / this.baseImage.width,
              pos.y / this.baseImage.height
            ) <= 0.01 &&
            this.isDrawing
          ) {
            this.objects[this.objectType].pop();
          }
          this.isDrawing = false;
        }
      }
    },
    handleDragStart() {
      this.isDragging = true;
    },
    handleDragEnd(event) {
      this.isDragging = false;
      const uuid = event.target.attrs.uuid;
      const type = event.target.attrs.type;
      const pos = event.target.getPosition();

      let posX = pos.x / this.baseImage.width;
      let posY = pos.y / this.baseImage.height;
      let draggedObject = this.objects[type].find(
        (object) => object.uuid == uuid
      );

      draggedObject.startPointX = posX;
      draggedObject.startPointY = posY;
    },
    isFenceCreated(object) {
      let check = this.fenceItems.findIndex((item) => item._id == object.uuid);
      return check == -1 ? false : true;
    },
    updateFence() {
      //delete fence
      async function deleteFence(guardian) {
        let fenceData = guardian.objectToFenceData();

        for (let i = 0; i < guardian.fenceItems.length; i++) {
          let check = fenceData.findIndex(
            (data) => data._id == guardian.fenceItems[i]._id
          );

          if (check == -1) {
            //fence has been deleted use delete
            await removeFence(
              guardian.inferenceCameraItem._id,
              guardian.fenceItems[i]._id
            );
          }
        }

        return guardian;
      }
      //create and update fence
      async function createUpdateFence(guardian) {
        let fenceData = guardian.objectToFenceData();

        for (let i = 0; i < fenceData.length; i++) {
          let check = guardian.fenceItems.findIndex(
            (item) => item._id == fenceData[i]._id
          );
          if (check == -1) {
            //fence not existed use post
            await addFence(guardian.inferenceCameraItem._id, fenceData[i]);
          } else {
            //fence existed use put
            await updateFence(
              guardian.inferenceCameraItem._id,
              fenceData[i]._id,
              fenceData[i]
            );
          }
        }
        return guardian;
      }

      async function update(guardian) {
        await deleteFence(guardian);
        await createUpdateFence(guardian);
        return guardian;
      }

      update(this)
        .then((guardian) => guardian.$router.go())
        .catch();
    },
    calculateP2PDistance(x1, y1, x2, y2) {
      return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
    },
    calculateP2LDistance(x, y, startPointX, startPointY, endPointX, endPointY) {
      let a = endPointY - startPointY;
      let b = startPointX - endPointX;
      let c = endPointX * startPointY - startPointX * endPointY;

      return (
        Math.abs(a * x + b * y + c) / Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2))
      );
    },
    createUuid() {
      var d = Date.now();
      if (
        typeof performance !== "undefined" &&
        typeof performance.now === "function"
      ) {
        d += performance.now(); //use high-precision timer if available
      }
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
    },
    test() {
      window.onunload = function () {
        var a_n = window.event.screenX - window.screenLeft;
        var a_b = a_n > document.documentElement.scrollWidth - 20;
        if ((a_b && window.event.clientY < 0) || window.event.altKey) {
          alert("關閉頁面行為");
        } else {
          alert("跳轉或者重新整理頁面行為");
        }
      };
    },
  },
};
</script>